const strings = {
  CANCEL: "Avbryt",
  DONE: "Skapa",
  CORPORATION_CREATED: "BRF skapad",
  INTERNAL_ERROR: "Ett oväntat fel har uppstått, var god försök igen.",
  NEW_CORPORATION: "Ny BRF",
  CORPORATION_NAME: "BRF",
  BILLING_AND_PHONE_EMAIL: "Email",
  CONTACT_NUMBER: "Telefon",
  CONTACT_FIRST_NAME: "Förnamn",
  CONTACT_LAST_NAME: "Efternamn",
  ADDRESS: "Adress",
  ZIP_CODE: "Postkod",
  CITY: "Stad",
  PRICE: "Pris",
  ORG_NUMBER: "Organisationnummer",
  CORP_ADMIN:
    "Företagsadmin (Sätt en egen mail här (be Kevin eller Love ta bort den sedan och använd ej dublett, exempel niklas+1@homepal.se sedan niklas+2@homepal.se osv) och logga in på admin.homepal.se och ställ in resten.)",
  CORP_ADMIN_EMAIL: "Företagsadmin (email)",
  PASSWORD: "Lösenord",
  MANDATORY_FIELD: "Fältet är oblikatoriskt",
  JANITOR: "Mottagare av fel"
};

export default strings;



// WEBPACK FOOTER //
// ./src/components/containers/CreateCorporationModal/strings.js